<mat-card appearance="outlined">
  <a [href]="scheme().files[1].url" target="_blank">
    <mat-card-header>
      <mat-card-title>{{scheme().schematicId}}</mat-card-title>
    </mat-card-header>
    <img mat-card-image [src]="scheme().files[0].url" [alt]="scheme().name" loading="lazy">
  </a>
  <mat-card-content>
    <small>{{scheme().name}}</small>
  </mat-card-content>
</mat-card>
